import SubcontractGoodReceiptSuggestionDetail from '@/models/SubcontractGoodReceipt/SubcontractGoodReceiptSuggestionDetail';

export default class SubcontractGoodReceiptSuggestionDetailFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.subcontractGoodReceiptId  = '';
		this.subcontractGoodReceiptSubcontractGoodReceiptNumber = '';
		this.controlCardId  = '';
		this.controlCardControlCardNumber = '';
		this.caseQty = '';
		this.usedQty = '';
		this.isScanned = false;
		this.subcontractGoodReceiptDetailId  = '';
		this.subcontractGoodReceiptDetailControlCard = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			subcontractGoodReceiptId : '0',
			subcontractGoodReceiptSubcontractGoodReceiptNumber : '0',
			controlCardId : '0',
			controlCardControlCardNumber : '0',
			caseQty : '0',
			usedQty : '0',
			isScanned : '0',
			subcontractGoodReceiptDetailId : '0',
			subcontractGoodReceiptDetailControlCard : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}